import {
  createContext,
  FC,
  ReactNode,
  useCallback,
  useContext,
  useMemo,
  useState,
} from "react";

interface NovoPedidoContextValue {
  isOpen: boolean;
  openNovoPedido: () => void;
  closeNovoPedido: () => void;
  registerOnSuccess: (cb: (() => void) | null) => void;
  notifySuccess: () => void;
}

const NovoPedidoContext = createContext<NovoPedidoContextValue>({
  isOpen: false,
  openNovoPedido: () => undefined,
  closeNovoPedido: () => undefined,
  registerOnSuccess: () => undefined,
  notifySuccess: () => undefined,
});

export const useNovoPedidoModal = () => useContext(NovoPedidoContext);

export const NovoPedidoProvider: FC<{ children: ReactNode }> = ({
  children,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [onSuccess, setOnSuccess] = useState<(() => void) | null>(null);

  const openNovoPedido = useCallback(() => setIsOpen(true), []);
  const closeNovoPedido = useCallback(() => setIsOpen(false), []);
  const registerOnSuccess = useCallback((cb: (() => void) | null) => {
    setOnSuccess(() => cb);
  }, []);
  const notifySuccess = useCallback(() => {
    onSuccess?.();
  }, [onSuccess]);

  const value = useMemo(
    () => ({
      isOpen,
      openNovoPedido,
      closeNovoPedido,
      registerOnSuccess,
      notifySuccess,
    }),
    [isOpen, openNovoPedido, closeNovoPedido, registerOnSuccess, notifySuccess],
  );

  return (
    <NovoPedidoContext.Provider value={value}>
      {children}
    </NovoPedidoContext.Provider>
  );
};
